<template>
  <div :class="['protocol-container', isMobile ? 'mobile' : '']">
    <div class="protocol">
      <p class="title">第三方SDK收集个人信息列表</p>
      <div class="container">
        <p>
          为确保部分独立功能的实现，我们的部分服务及功能由第三方SDK提供。我们将审慎评估该等SDK的使用目的。
        </p>
        <p>
          请您理解，第三方SDK的功能和服务是不断更新和发展的，其处理的数据类型等内容可能会因为功能或策略调整存在一定的变化，请以第三方公示的有关个人信息的介绍为准。
        </p>
        <table class="table">
          <tr class="tb-title">
            <th>SDK名称</th>
            <th>第三方名称</th>
            <th>使用目的</th>
            <th>数据类型</th>
            <th>开放平台/隐私政策链接</th>
          </tr>
          <tr>
            <td>微信分享SDK</td>
            <td>腾讯公司</td>
            <td>用户可使用微信登陆应用并帮助用户将特定内容分享到微信</td>
            <td>设备标识信息、网络状态</td>
            <td>
              <a href="https://privacy.qq.com/policy/tencent-privacypolicy">
                https://privacy.qq.com/policy/tencent-privacypolicy
              </a>
            </td>
          </tr>
          <tr>
            <td>新浪微博开放平台SDK</td>
            <td>北京微梦创科网络技术有限公司</td>
            <td>用户可使用微博登录应用帮助用户将特定内容分享到新浪微博</td>
            <td>设备标识信息、网络状态</td>
            <td>
              <a href="https://open.weibo.com/">https://open.weibo.com/</a>
            </td>
          </tr>
          <tr>
            <td>腾讯Bugly</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>运营统计和收集并上报应用异常信息</td>
            <td>设备标识信息、网络状态、低级别系统日志文件</td>
            <td>
              <a href="https://privacy.qq.com/document/priview/fbd2c3f898df4c1c869925dd49d57827">
                https://privacy.qq.com/document/priview/fbd2c3f898df4c1c869925dd49d57827
              </a>
            </td>
          </tr>
          <tr>
            <td>支付宝SDK</td>
            <td>支付宝（中国）网络技术有限公司</td>
            <td>帮助用户在应用内使用支付宝</td>
            <td>设备标识信息、网络状态</td>
            <td>
              <a href="https://opendocs.alipay.com/open/01g6qm">
                https://opendocs.alipay.com/open/01g6qm"
              </a>
            </td>
          </tr>
          <tr>
            <td>华为推送SDK</td>
            <td>华为软件技术有限公司</td>
            <td>用于在华为设备上推送消息</td>
            <td>设备标识信息</td>
            <td>
              <a
                href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021"
              >
                https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/privacy-statement-0000001050042021
              </a>
            </td>
          </tr>
          <tr>
            <td>华为HMS Scan Kit</td>
            <td>华为软件技术有限公司</td>
            <td>构建扫码能力，为用户提供二维码与条形码扫描，解析二维码并完成支付</td>
            <td>设备信息、网络信息、应用信息</td>
            <td>
              <a
                href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/service-introduction-0000001050041994#section1720695013254"
              >
                https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/service-introduction-0000001050041994#section1720695013254
              </a>
            </td>
          </tr>
          <tr>
            <td>高德地图SDK</td>
            <td>高德软件有限公司</td>
            <td>为用户提供2D、3D地图，提供地图搜索、定位能力</td>
            <td>设备标识信息、网络状态、地理位置信息</td>
            <td>
              <a href="https://lbs.amap.com/pages/privacy/">https://lbs.amap.com/pages/privacy/</a>
            </td>
          </tr>
          <tr>
            <td>银联SDK</td>
            <td>中国银联</td>
            <td>帮助用户在应用内使用银联</td>
            <td>设备标识信息、网络状态、地理位置信息</td>
            <td>
              <a href="https://open.unionpay.com/tjweb/index">
                https://open.unionpay.com/tjweb/index
              </a>
            </td>
          </tr>
          <tr>
            <td>微信支付SDK</td>
            <td>财付通支付科技有限公司</td>
            <td>为用户提供应用内微信支付功能</td>
            <td>设备标识信息、网络状态</td>
            <td>
              <a href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F">
                https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F
              </a>
            </td>
          </tr>
          <tr>
            <td>百度统计SDK</td>
            <td>北京百度网讯科技有限公司</td>
            <td>优化产品功能，提升用户体验</td>
            <td>备标识信息、APP安装列表、APP崩溃以及错误信息</td>
            <td>
              <a href="https://tongji.baidu.com/web/help/article?id=330&type=0&castk=LTE%3D">
                https://tongji.baidu.com/web/help/article?id=330&type=0&castk=LTE%3D
              </a>
            </td>
          </tr>
          <tr>
            <td>火山引擎增长分析SDK</td>
            <td>北京火山引擎科技有限公司</td>
            <td>优化产品功能，提升用户体验</td>
            <td>设备备标识信息、产品崩溃以及错误信息</td>
            <td>
              <a href="https://www.volcengine.com/docs/6285/72216">
                https://www.volcengine.com/docs/6285/72216
              </a>
            </td>
          </tr>
          <tr>
            <td>倍孜SDK</td>
            <td>上海倍孜网络技术有限公司</td>
            <td>提供商业化效果广告投放资源</td>
            <td>
              设备/网络/系统信息【设备品牌、设备型号、设备时区、设备语言、系统版本、网络类型、UserAgent信息、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商、传感器信息(例如：重力传感器、加速度传感器、方向传感器、陀螺仪、压力传感器、重力传感器、线性加速度传感器)、掠过手势内容、cpu】、标识符【OAID】、应用信息【开发者应用名、应用版本号、应用包名、运行状态】、使用数据【如产品交互数据、广告数据(如展示、点击、转化广告数据)】、诊断数据【如崩溃数据、性能数据】
            </td>
            <td>
              <a href="http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy">
                http://sdkdoc.beizi.biz/#/zh-cn/guide/UsePrivacy
              </a>
            </td>
          </tr>
          <tr>
            <td>美摄SDK</td>
            <td>北京美摄网络科技有限公司</td>
            <td>针对传入的音视频等图形图像进行渲染等服务，从而合成视频</td>
            <td>
              <div>权限：摄像头权限、麦克风权限、读写系统设置、Wi-Fi或蜂窝网络</div>
              <div>信息类型：用户所有个人隐私信息，不收集任何用户信息</div>
            </td>
            <td>
              <div>
                <a href="https://vsapi.meishesdk.com/app/privacy/privacy-policy.html">
                  https://vsapi.meishesdk.com/app/privacy/privacy-policy.html
                </a>
              </div>
              <div>
                <a href="https://www.meishesdk.com/privacy-v2.html">
                  https://www.meishesdk.com/privacy-v2.html
                </a>
              </div>
              <div>
                <a href="https://www.meishesdk.com/privacy-v2.html">
                  https://www.meishesdk.com/privacy-v2.html
                </a>
              </div>
            </td>
          </tr>
          <tr>
            <td>字节跳动SDK</td>
            <td>字节跳动</td>
            <td>程序化广告推送、广告监测与小归因</td>
            <td>
                粗略位置信息、设备信息(如设备制造商、设备型号、操作系统版本等)、设备标识符(如IMVE、IDFA等)、获取设备序列号、应用信息(宿主应用的包名、版本号)、Android lD、获取SD卡数据、、广告数据(如曝光、点击数据等)、运营商、应用运行列表、BSSID、IP地址。
            </td>
            <td>
              <a href="https://security.bytedance.com/privacy-security/">
                https://security.bytedance.com/privacy-security/
              </a>
            </td>
          </tr>
          <tr>
            <td>穿山甲 SDK</td>
            <td>深圳市腾讯计算机系统有限公司</td>
            <td>
                <div>广告投放合作、广告归因、反作弊</div>
                <div>减少App崩溃、提供稳定可靠的服务</div>
                <div>我们可能会对您提供或我们收集的信息进行去标识化地研究、统计分析和预测，用于改善和提升穿山甲平台的服务，为用户营销决策提供产品或技术服务支撑</div>
            </td>
            <td>
                <div>[设备信息]【双端】设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息等基础信息
                    【仅Android】AndroidID
                    【仅iOS】手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息、IDFV
                    【双端】无线网SSID名称、WiFi路由器MAC地址、设备的MAC地址（如为iOS端，则仅适用于IOS3200以下版本）
                    【仅Android】设备标识符（如IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build-serial，具体字段因软硬件版本不同而存在差异）
                    【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）
                    应用的进程名称
                    运行状态
                </div>
                <div>[应用信息]
                    【仅Android】开发者应用名、应用包名、版本号、应用前后台状态
                    【仅Android】应用列表信息
                </div>
                <div>[广告信息]
                    【双端】对广告的展示、点击及转化等交互数据
                </div>
                <div>
                    [位置信息] 位置信息
                </div>
                <div>[性能数据]
                    【双端】如崩溃数据、性能数据
                    减少App崩溃、提供稳定可靠的服务
                </div>
                <div>
                    [其他信息]运营商信息、设备时区
                </div>
            </td>
            <td>
              <a href="https://www.pangle.cn/privacy?from=ad.oceanengine.com">
                https://www.pangle.cn/privacy?from=ad.oceanengine.com
              </a>
            </td>
          </tr>
          <tr>
            <td>优量汇 SDK</td>
            <td>计算机系统有限公司</td>
            <td>基于用户设备信息进行广告投放与监测归因。
                通过崩溃信息，以此来优化代码缺陷，最大程度减少App崩溃。
                通过收集SDK运行过程中性能数据，以优化SDK的性能。
                统计广告数据，以用于广告主统计投放结果。包括不限于：请求、展示 、点击 、转化等，用于广告主统计投放结果</td>
            <td>
                <div>
                    [粗略位置信息]【仅 Android】基站、附近的WIFI、连接的WIFI【双端】精确位置信息
                </div>
                <div>
                    设备信息]
                   【双端】设备制造商、品牌、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、时区、网络类型、运营商、加速度传感器
                   【仅Android】磁力、陀螺仪传感器
                   【仅iOS】设备名称、系统启动时间、系统语言、磁盘空间、陀螺仪、压力传感器等基础信息
                </div>
                <div>
                    [标识符]
                    【仅Android】OAID
                    【仅Android】 IMEI、Android_ID
                    【仅iOS】IDFV、 IDFA
                </div>
                <div>
                    [应用信息]
                   【双端】宿主应用的包名、版本号
                   【仅Android】 宿主应用的进程名称、运行状态、可疑行为
                   【双端】应用安装信息
                </div>
                <div>
                    [使用数据]【双端】如产品交互数据、广告数据（如展示、点击、转化广告数据）
                </div>
                <div>
                    [诊断数据]【双端】如崩溃数据、性能数据
                </div>
            </td>
            <td>
              <a href="https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983">
                https://e.qq.com/dev/help_detail.html?cid=2005&pid=5983
              </a>
            </td>
          </tr>
          <tr>
            <td>openinstall</td>
            <td>深圳市分秒网络科技有限公司</td>
            <td>用户传入或系统API采集，用于移动广告效果监测，用于数据统计作弊监控、数据统计和分析</td>
            <td>
                设备品牌、设备型号、操作系统版本、IP地址、粘贴板（剪切板）、Android ID、设备序列号（SerialNumber）、本地存储权限、IMEI、IDFA、OAID、Mac地址
            </td>
            <td>
              <a href="https://www.openinstall.io/privacy.html">
                https://www.openinstall.io/privacy.html
              </a>
            </td>
          </tr>
          <tr>
            <td>阿里云号码认证SDK（Android端、iOS端）</td>
            <td>阿里巴巴云计算（北京）有限公司</td>
            <td>集成三大运营商用户本机号码认证及一键登录及技术服务SDK，实现本机号码一键登录和认证。</td>
            <td>
                网络类型、切换wifi和蜂窝网络通道、IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息、SIM卡状态、运营商信息
            </td>
            <td>
              <a href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html">
                https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html
              </a>
            </td>
          </tr>
          <tr>
            <td>Octopus SDK (章鱼SDK)</td>
            <td>北京圣盈科技有限公司</td>
            <td>基于用户设备信息调整广告投放策略，基于用户设备信息提供统计分析服务，基于用户设备信息进行基础的反作弊分析，基于用户设备信息实现广告正常显示与交互功能的实现，通过崩溃信息，以此来优化代码缺陷，最大程度减少App崩溃，通过收集SDK运行过程中性能数据，以优化SDK的性能统计广告数据，以用于广告主统计投放结果。包括不限于：请求、展示 、点击 、转化等，用于广告流程分析，获取信息只用于功能实现并不会收集与保存信息</td>
            <td>
              「双端」设备品牌、设备型号、设备时区、设备语言、系统版本、开发者应用名、应用版本号、应用包名、网络类型、UserAgent信息、网络状态、崩溃信息、性能数据、屏幕高宽、屏幕方向、屏幕DPI信息、系统更新时间、开机时间、磁盘空间、物理内存、运营商 [仅Android] 设备ID（OAID、GAID）、IMEI 用户授权才收集、USB调试模式、cpu、运行状态 [仅ios]  设备ID（IDFA 用户授权才收集）、IDFV
            </td>
            <td>
              <a href="https://doc.adintl.cn/docs/SDK隐私政策/UsePrivacy">
                https://doc.adintl.cn/docs/SDK隐私政策/UsePrivacy
              </a>
            </td>
          </tr>
          <tr>
            <td>快手联盟SDK</td>
            <td>北京快手科技有限公司</td>
            <td>广告投放合作、广告归因、反作弊、安全</td>
            <td>
              基础信息:设备品牌、设备型号、软件系统版本、存储信息、运营商信息、设备时区、设备语言、网络信息基等基础信息；设备标识:IMEI、MEID、OAID、AndroidId、IMSI、ICCID；位置信息:IP地址、MAC地址、GPS位置信息、基站信息、WIFI信息、WLAN接入点(如SSID，BSSID)；应用信息:应用安装列表、应用的进程名称、运行状态；其他信息:传感器信息、sim卡激活信息；获取权限:【Android】；必选权限:访问互联网、网络状态、手机Wii状态、安装应用;可选权限:获取设备标识、获取MAC地址;【ios】网络权限、设备信息(IDFA)、获取粗略位置
            </td>
            <td>
              <a href="https://u.kuaishou.com/home/help/detai/1337/1220">
                https://u.kuaishou.com/home/help/detai/1337/1220
              </a>
            </td>
          </tr>
          <tr>
            <td>汇盈（汇盈SDK）</td>
            <td>上海震来科技有限公司</td>
            <td>广告投放及广告监测归因、反作弊</td>
            <td>
              设备信息
            【双端】设备品牌，型号，软件系统版本，屏幕密度屏，幕分辨率，设备语言，可用存储空间大小等
            【双端】电池电量，磁盘总空间，系统总内存空间
            【仅Android】CPU型号
            【仅Android】AndroidID，OAID
            【仅iOS】手机系统重启时间，IDFV，CAID，IDFA
            可选信息：
            【仅Android】设备标识符（如IMSI），具体字段因软硬件版本不同而存在差异）
            【仅iOS】设备标识符（如IDFA，具体字段因软硬件版本不同而存在差异）
            应用信息
            【双端】应用名称，应用包名，应用版本等
            网络信息
            【双端】运营商信息，Wi-Fi状态，网络信号强度
            传感器信息
            【双端】加速度传感器，陀螺仪传感器，重力传感器
            广告信息
            【双端】对广告的展示，点击及转化等交互数据（曝光监测、点击监测、点击坐标宏替换等）
            诊断数据
            【双端】如崩溃数据，性能数据
            位置信息
            【Android】精确位置信息、粗略位置信息
            【IOS】粗略位置信息
            </td>
            <td>
              <a href="https://www.zhltech.net/html/privacy.html">
                https://www.zhltech.net/html/privacy.html
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
      //   tableList:[
      //     {name:'美摄SDK',thirdName:'北京美摄网络科技有限公司',purpose:'针对传入的音视频等图形图像进行渲染等服务，从而合成视频',type:'权限：摄像头权限、麦克风权限、读写系统设置、Wi-Fi或蜂窝网络,信息类型：用户所有个人隐私信息，不收集任何用户信息',linkUrl:'https://vsapi.meishesdk.com/app/privacy/privacy-policy.html,https://www.meishesdk.com/privacy-v2.html,https://www.meishesdk.com/privacy-v2.html'},
      //   ]//因为每次产品提供的数据格式展示不一样 所以没用这个参数
    };
  },
  methods: {
    checkIsMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = flag;
    },
  },
  mounted() {
    this.isMobile = this.checkIsMobile();
    if (this.isMobile) {
      document.title = '魔音工坊';
    }
  },
};
</script>

<style lang="less" scoped>
.protocol-container {
  font-size: 16px;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background: #fff;
  color: #1f2329 !important;
  .highlight {
    font-weight: 800;
  }
  html {
    font-size: 16px !important;
    overflow: auto;
  }
  .protocol {
    min-width: 470px;
    max-width: 790px;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 20px 40px;
    margin: 40px auto 0;
    background: #fff;
    box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
    .title {
      margin: 36px 0 22px;
      text-align: center;
      font-size: 34px;
      font-weight: 500;
      color: #1f2329;
      padding: 40px;
    }
    .container {
      margin-top: 20px;
      p {
        margin-bottom: 20px;
        text-indent: 2em;
      }
      .table {
        width: 100%;
        max-width: 1000px;
        margin: auto;
      }

      .table th:nth-of-type(1) {
        width: 10%;
      }
      .table th:nth-of-type(2) {
        width: 12%;
      }
      .table th:nth-of-type(3) {
        width: 28%;
      }
      .table th:nth-of-type(4) {
        width: 20%;
      }
      .table th:nth-of-type(5) {
        width: 30%;
      }
      .table,
      .table td,
      .table th {
        border: solid 2px #ddd;
        border-collapse: collapse;
        font-size: 16px;
      }

      .table th {
        // background-color: #eee;
        height: 40px;
      }
      .table td {
        padding: 5px;
      }
      a {
        word-wrap: break-word;
        word-break: break-all;
      }
      a,
      a:hover {
        // color: #333;
        text-decoration: underline;
      }
      .third-content {
        max-width: 1000px;
        margin: 10px auto;
      }
      .third-content p {
        font-size: 14px;
      }
      .p-strong {
        font-weight: bold;
        // margin-top: 40px;
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .protocol {
    width: 80%;
  }
}
// @media screen  and (max-width: 1400px){
//   .protocol{
//     width:80%
//   }
// }
@media screen and (max-width: 1279px) {
  .protocol {
    width: 70%;
  }
}
@media screen and (max-width: 900px) {
  .protocol {
    width: calc(100% - 40px);
  }
}
.mobile {
  .protocol {
    min-width: auto;
    max-width: none;
    width: 100%;
    border-radius: 4rpx;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 40rpx;
    margin: 40rpx auto 0;
    padding: 0 20rpx;
    background: #fff;
    box-shadow: 0px 0rpx 11px 0rpx rgba(63, 95, 150, 0.04);
    .title {
      margin: 36rpx 0 22rpx;
      text-align: center;
      font-size: 34rpx;
      font-weight: 500;
      color: #1f2329;
      padding: 40rpx;
    }
    .container {
      margin-top: 20rpx;
      p {
        margin-bottom: 20rpx;
        text-indent: 2em;
      }
      .table {
        width: 100%;
        // max-width: 1000px;
        margin: auto;
      }

      .table th:nth-of-type(1) {
        width: 10%;
      }
      .table th:nth-of-type(2) {
        width: 12%;
      }
      .table th:nth-of-type(3) {
        width: 28%;
      }
      .table th:nth-of-type(4) {
        width: 20%;
      }
      .table th:nth-of-type(5) {
        width: 30%;
      }
      .table,
      .table td,
      .table th {
        border: solid 1rpx #ddd;
        border-collapse: collapse;
        font-size: 16rpx;
      }

      .table th {
        // background-color: #eee;
        height: 40rpx;
      }
      .table td {
        padding: 5rpx;
      }
      a {
        word-wrap: break-word;
        word-break: break-all;
      }
      a,
      a:hover {
        // color: #333;
        text-decoration: underline;
      }
      .third-content {
        // max-width: 1000px;
        margin: 10rpx auto;
      }
      .third-content p {
        font-size: 14rpx;
      }
      .p-strong {
        font-weight: bold;
        // margin-top: 40px;
      }
    }
  }
}
// .mobile {
//   &.minip {
//     .protocol {
//       min-width: auto;
//       max-width: none;
//       width: 100%;
//       border-radius: 4px;
//       height: 100%;
//       box-sizing: border-box;
//       padding-bottom: 40px;
//       margin: 40px auto 0;
//       background: #fff;
//       box-shadow: 0px 0px 11px 0px rgba(63, 95, 150, 0.04);
//       .title {
//         font-size: 3.4rem;
//       }
//       .container {
//         font-size: 20px;
//         p {
//           margin-bottom: 20px;
//           text-indent: 2em;
//           font-size: 1.9rem;
//         }
//         .table,
//         .table th,
//         .table td {
//           font-size: 1.6rem;
//         }
//         .title {
//           font-size: 2rem;
//         }
//       }
//     }
//   }
// }
</style>
